import { AlarmClock, BadgeCheck, CircleX } from 'lucide-react'

import DisplayTooltipOnHover from 'components/reusable/DisplayTooltipOnHover'
import { Badge } from 'slab'
import { AdminEmployerBankOnboardingStatus } from 'utils/web_api.schemas'

interface EmployerComplianceStatusBadgeProps {
  status: AdminEmployerBankOnboardingStatus
}

const getIcon = (status: AdminEmployerBankOnboardingStatus) => {
  if (status === AdminEmployerBankOnboardingStatus.passing) {
    return BadgeCheck
  } else if (status === AdminEmployerBankOnboardingStatus.failing) {
    return CircleX
  } else {
    return AlarmClock
  }
}

const getBadgeType = (status: AdminEmployerBankOnboardingStatus): 'success' | 'neutral' | 'critical' => {
  if (status === AdminEmployerBankOnboardingStatus.passing) {
    return 'success'
  } else if (status === AdminEmployerBankOnboardingStatus.failing) {
    return 'critical'
  } else {
    return 'neutral'
  }
}

const getHoverDescription = (status: AdminEmployerBankOnboardingStatus) => {
  if (status === AdminEmployerBankOnboardingStatus.passing) {
    return 'Employer is passing requirements for all bank partners.'
  } else if (status === AdminEmployerBankOnboardingStatus.failing) {
    return 'One or more checks are failing, blocking us from onboarding to a bank partner.'
  } else {
    return 'Manual steps are still required to onboard to a bank partner.'
  }
}

const getDisplayText = (status: AdminEmployerBankOnboardingStatus) => {
  if (status === AdminEmployerBankOnboardingStatus.passing) {
    return 'Passing'
  } else if (status === AdminEmployerBankOnboardingStatus.failing) {
    return 'Failing'
  } else {
    return 'Pending'
  }
}

const EmployerComplianceStatusBadge = ({ status }: EmployerComplianceStatusBadgeProps) => {
  if (status === AdminEmployerBankOnboardingStatus.none) {
    return <span className='text-gray-400 font-light'>&mdash;</span>
  }

  return (
    <DisplayTooltipOnHover text={getHoverDescription(status)}>
      <Badge
        type={getBadgeType(status)}
        leftIcon={getIcon(status)}
        title={getHoverDescription(status)}
      >
        {getDisplayText(status)}
      </Badge>
    </DisplayTooltipOnHover>
  )
}

export default EmployerComplianceStatusBadge
